export const DOCUMENT_BATCH_SIZE=1000;
export const SERVICE = ["mythical", "story-protocol", "subwallet"] as const;
